/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrokerGroupsResponseDto
 */
export interface BrokerGroupsResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof BrokerGroupsResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BrokerGroupsResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof BrokerGroupsResponseDto
     */
    brokerGroup: string;
    /**
     * 
     * @type {string}
     * @memberof BrokerGroupsResponseDto
     */
    brokerGroupName: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrokerGroupsResponseDto
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the BrokerGroupsResponseDto interface.
 */
export function instanceOfBrokerGroupsResponseDto(value: object): value is BrokerGroupsResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('brokerGroup' in value) || value['brokerGroup'] === undefined) return false;
    if (!('brokerGroupName' in value) || value['brokerGroupName'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function BrokerGroupsResponseDtoFromJSON(json: any): BrokerGroupsResponseDto {
    return BrokerGroupsResponseDtoFromJSONTyped(json, false);
}

export function BrokerGroupsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerGroupsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'brokerGroup': json['brokerGroup'],
        'brokerGroupName': json['brokerGroupName'],
        'isActive': json['isActive'],
    };
}

export function BrokerGroupsResponseDtoToJSON(json: any): BrokerGroupsResponseDto {
    return BrokerGroupsResponseDtoToJSONTyped(json, false);
}

export function BrokerGroupsResponseDtoToJSONTyped(value?: BrokerGroupsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'brokerGroup': value['brokerGroup'],
        'brokerGroupName': value['brokerGroupName'],
        'isActive': value['isActive'],
    };
}

